import React, { useState, useEffect } from 'react';

const getData = async (setData) => {};

const useDateWithMD5Check = () => {};

export default useDateWithMD5Check;
